// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 指定当前主控 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/assignController */
export async function assignBossActivityProcessController(
  body: CoreAPI.ActivityProcessAssignControllerRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessCommandResult>(
    '/bossApi/conference/core/activityProcess/v1/assignController',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 校正舞台复盘时间 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/correctStageTimes */
export async function correctBossActivityProcessStageTimes(
  body: CoreAPI.ActivityProcessCorrectStageTimesRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessProcessDetail>(
    '/bossApi/conference/core/activityProcess/v1/correctStageTimes',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 创建关联返工任务 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/createRework */
export async function createBossActivityProcessRework(
  body: CoreAPI.ActivityProcessCreateReworkRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessTaskDetail>(
    '/bossApi/conference/core/activityProcess/v1/createRework',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询活动流程入口 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/entry */
export async function getBossActivityProcessEntry(
  body: CoreAPI.ActivityProcessEmptyRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessEntry>(
    '/bossApi/conference/core/activityProcess/v1/entry',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询本场流程 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/get */
export async function getBossActivityProcess(
  body: CoreAPI.ActivityProcessGetProcessRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessProcessDetail>(
    '/bossApi/conference/core/activityProcess/v1/get',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 核实本人流程指令结果 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/getCommandResult */
export async function getBossActivityProcessCommandResult(
  body: CoreAPI.ActivityProcessCommandQueryRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessCommandResult>(
    '/bossApi/conference/core/activityProcess/v1/getCommandResult',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询流程操作历史 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/history */
export async function pageBossActivityProcessHistory(
  body: CoreAPI.ActivityProcessHistoryRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessPageActivityProcessAudit>(
    '/bossApi/conference/core/activityProcess/v1/history',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 启用完成或归档流程 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/lifecycle */
export async function executeBossActivityProcessLifecycle(
  body: CoreAPI.ActivityProcessLifecycleRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessCommandResult>(
    '/bossApi/conference/core/activityProcess/v1/lifecycle',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询有权访问的活动流程 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/page */
export async function pageBossActivityProcesses(
  body: CoreAPI.ActivityProcessPageRequestRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessPageActivityProcessProcessSummary>(
    '/bossApi/conference/core/activityProcess/v1/page',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 保存本场流程配置 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/saveDefinition */
export async function saveBossActivityProcessDefinition(
  body: CoreAPI.ActivityProcessSaveDefinitionRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessProcessDetail>(
    '/bossApi/conference/core/activityProcess/v1/saveDefinition',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 保存本场职责授权 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/saveGrants */
export async function saveBossActivityProcessGrants(
  body: CoreAPI.ActivityProcessSaveGrantsRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessProcessDetail>(
    '/bossApi/conference/core/activityProcess/v1/saveGrants',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 设置本场户外控制模式 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/setOutdoor */
export async function setBossActivityProcessOutdoor(
  body: CoreAPI.ActivityProcessSetOutdoorRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessProcessDetail>(
    '/bossApi/conference/core/activityProcess/v1/setOutdoor',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 校验本场流程配置 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/activityProcess/v1/validate */
export async function validateBossActivityProcess(
  body: CoreAPI.ActivityProcessProcessRefRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessValidation>(
    '/bossApi/conference/core/activityProcess/v1/validate',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
